/**
 * Deterministic pseudo-random generator (mulberry32).
 * Used for generative scene layout so the composition is reproducible
 * frame-to-frame and testable — the same seed always yields the same universe.
 */
export function createRandom(seed: number): () => number {
  let state = seed >>> 0;
  return (): number => {
    state = (state + 0x6d_2b_79_f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4_294_967_296;
  };
}
